import React from 'react';
import { classNames } from '@shopify/css-utilities';
import styles from './Icon.scss.mjs';

function Icon({
  source,
  disabled
}) {
  const SourceComponent = source;
  const iconClassNames = classNames(styles.Icon, disabled && styles.disabled);
  return /*#__PURE__*/React.createElement("div", {
    className: iconClassNames
  }, /*#__PURE__*/React.createElement(SourceComponent, {
    className: styles.Svg,
    focusable: "false",
    "aria-hidden": "true"
  }));
}

export { Icon };
